import { render, staticRenderFns } from "./productChart.vue?vue&type=template&id=7d038bb0"
import script from "./productChart.vue?vue&type=script&lang=js"
export * from "./productChart.vue?vue&type=script&lang=js"
import style0 from "./productChart.vue?vue&type=style&index=0&id=7d038bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports